import { Component, OnInit } from '@angular/core';
import {DataService} from '../../../../../../services/commande-client/data.service';

@Component({
  selector: 'app-partiellemenr-paye-facture',
  templateUrl: './partiellemenr-paye-facture.component.html',
  styleUrls: ['./partiellemenr-paye-facture.component.scss']
})
export class PartiellemenrPayeFactureComponent implements OnInit {

    constructor(private dataService: DataService) {}

    ngOnInit(): void {
        this.dataService.filterOrdersByStatus('Tous');
    }

}
